import {DisplaySettings, EditOutlined} from '@mui/icons-material';
import {Badge, Button, CardActions} from '@mui/material';
import {useOptimisticSearchParams} from 'nuqs/adapters/react-router/v7';
import {NavLink, useParams} from 'react-router';
import ZoomMapToExtentButton from '../panels/browse/ZoomToMapExtentButton.tsx';
import {CONFIGURATION_APP_URL} from '@src/config';
import {
  ANALYZE_ROUTE_KEYS,
  ANALYZE_VISUALIZE_ROUTE,
} from '@src/constants/routes';
import {useCollectionExtentInView} from '@src/hooks/useCollectionExtentInView.ts';
import useVisualizationParams from '@src/hooks/useVisualizationParams';
import dimensions from '@src/styles/dimensions';

export const VisualizeActions = () => {
  const {'*': splatPath} = useParams() as {'*': string};
  const searchParams = useOptimisticSearchParams();
  const {configurationId, settingsEffectsApplies, layerId, collectionId} =
    useVisualizationParams();
  const queryString = searchParams?.toString() ? `?${searchParams}` : '';
  const onEffects = splatPath === ANALYZE_ROUTE_KEYS.EFFECTS;
  const editConfigurationLink = `${CONFIGURATION_APP_URL}#/${configurationId}`;
  const doesIntersectWithView = useCollectionExtentInView(collectionId);

  return (
    <CardActions
      sx={theme => ({
        justifyContent: 'flex-start',
        gap: 2,
        backgroundImage: theme.vars?.overlays[1],
        borderTop: 1,
        borderTopColor: 'divider',
        paddingInline: `${dimensions.leftSidebar.contentMargin}px`,
        paddingBlock: `${dimensions.leftSidebar.contentMargin * 0.75}px`,
      })}
    >
      <Button
        color="secondary"
        variant="outlined"
        size="small"
        startIcon={<EditOutlined />}
        sx={{padding: '4px 9px'}}
        component="a"
        href={editConfigurationLink}
        role="button"
      >
        Configuration
      </Button>
      {layerId && (
        <Badge
          variant="dot"
          color="primary"
          invisible={!settingsEffectsApplies}
        >
          <Button
            color={onEffects ? 'primary' : 'secondary'}
            variant="outlined"
            component={NavLink}
            role="button"
            to={`${onEffects ? `/${ANALYZE_VISUALIZE_ROUTE}` : ANALYZE_ROUTE_KEYS.EFFECTS}${queryString}`}
            size="small"
            sx={{height: 32, paddingInline: 0, minWidth: 35}}
            title={`Toggle settings & effects${settingsEffectsApplies ? ' (some effects active)' : ''}`}
          >
            <DisplaySettings fontSize="small" />
          </Button>
        </Badge>
      )}
      {doesIntersectWithView === false && (
        <ZoomMapToExtentButton
          component={Button}
          collectionId={collectionId}
          rootProps={{
            sx: {
              height: 32,
              paddingInline: 0,
              minWidth: 35,
              marginInlineStart: 0,
            },
            component: NavLink,
          }}
        />
      )}
    </CardActions>
  );
};
export default VisualizeActions;
